
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/features",
      function () {
        return require("private-next-pages/features/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/features"])
      });
    }
  